<template>
  <div class="devices-status-container">
    <div class="section-header">
      <h4 class="section-title">
        {{ $t("globals.current_devices_status") }}:
        <v-icon v-if="devicesStatsLoading" name="spinner" spin></v-icon>
      </h4>
    </div>
    <div class="table-wrapper" style="position: relative; min-height: 200px;">
      <div v-if="devicesStatsLoading" class="loading-overlay">
        <div class="spinner"></div>
        <p>{{ $t("globals.loading") }}...</p>
      </div>
      <table class="modern-table">
        <thead>
          <tr>
            <th>Type</th>
            <th>Dongel</th>
            <th>Blackbox</th>
            <th>Old CT</th>
            <th>Blackbox 4G</th>
            <th>Dongel 4G</th>
            <th>CMM1</th>
            <th>CMM3</th>
            <th>CMM4</th>
            <th>AT4M</th>
            <th>TW Dashcam</th>
            <th>Velcare</th>
            <th>Velcare VB</th>
            <th>RNET</th>
            <th>All</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in device_stats" :key="item.type">
            <td>
              <span :class="[deviceTypeVariant(item.type)]">{{ item.type }}</span>
            </td>
            <td>{{ item.dongel }}</td>
            <td>{{ item.blackbox }}</td>
            <td>{{ item.old_ct }}</td>
            <td>{{ item.blackbox4g }}</td>
            <td>{{ item.dongel4g }}</td>
            <td>{{ item.cmm1 }}</td>
            <td>{{ item.cmm3 }}</td>
            <td>{{ item.cmm4 }}</td>
            <td>{{ item.at4m }}</td>
            <td>{{ item.twdashcam }}</td>
            <td>{{ item.velcare }}</td>
            <td>{{ item.velcare_vb }}</td>
            <td>{{ item.rnet }}</td>
            <td>{{ item.all }}</td>
          </tr>
        </tbody>
      </table>
      <div v-if="!devicesStatsLoading && device_stats.length === 0" class="empty-state">
        <p>{{ $t("globals.no_results") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      devicesStatsLoading: false,
      device_stats: []
    };
  },
  methods: {
    ...mapActions("axios_mod", ["simpleFetch"]),
    fetchDevicesStats() {
      const data = {
        query: `
          query {
            DevicesStats
          }
        `
      };

      this.devicesStatsLoading = true;
      this.simpleFetch({ data, this_ref: this }).then((res) => {
        if (res) {
          this.device_stats = res.DevicesStats.map(item => {
            return {
              type: item[0],
              dongel: item[1],
              blackbox: item[2],
              old_ct: item[3],
              blackbox4g: item[4],
              dongel4g: item[5],
              cmm1: item[6],
              cmm3: item[7],
              cmm4: item[8],
              at4m: item[9],
              twdashcam: item[10],
              velcare: item[11],
              velcare_vb: item[12],
              rnet: item[13],
              all: item[14]
            }
          })
        }
      }).finally(() => {
        this.devicesStatsLoading = false;
      });
    },
    deviceTypeVariant(type) {
      let variant = "";

      switch (type) {
        case "active":
          variant = "text-success";
          break;
        case "stock":
          variant = "text-warning";
          break;
        case "terminated":
          variant = "text-danger";
          break;
        case "warranty":
          variant = "text-danger";
          break;
      }
      return variant;
    }
  },
  computed: {
    ...mapGetters(["getUserSystem"])
  },
  watch: {
    getUserSystem: function () {
      this.fetchDevicesStats();
    }
  },
  mounted() {
    this.fetchDevicesStats();
  }
};
</script>

<style scoped>
.devices-status-container {
  padding: 16px;
}

.section-header {
  margin-bottom: 16px;
}

.section-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #2d3748;
  margin: 0;
}

.text-success {
  color: #388e3c;
  font-weight: 600;
}

.text-warning {
  color: #f57c00;
  font-weight: 600;
}

.text-danger {
  color: #d32f2f;
  font-weight: 600;
}
</style>
